import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, BarChart3, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-slate-50" data-id="element-87">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#0f172a 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-88"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-89">
        <div className="max-w-4xl" data-id="element-90">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-slate-200 text-xs font-medium text-slate-600 mb-8 shadow-sm" data-id="element-91">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-92"></span>
            Kompetenzzentrum für Exzellenz im Vertrieb
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-slate-900 tracking-tight mb-8 leading-[1.1]" data-id="element-93">
            Exzellenz im Vertrieb <br className="hidden md:block" data-id="element-94" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-900 to-slate-600" data-id="element-95">
              neu gedacht.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed" data-id="element-96">
            Wir helfen Unternehmen, ihren Vertrieb effizienter, skalierbarer und
            zukunftsfähig zu machen – mit Technologie, Struktur und Klarheit.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-97">
            <Button size="lg" icon onClick={() => window.location.href = '#contact'} data-id="element-98">
              Erstgespräch vereinbaren
            </Button>
            <Button variant="outline" size="lg" onClick={() => window.location.href = '#about'} data-id="element-99">
              Mehr erfahren
            </Button>
          </div>

          <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col sm:flex-row gap-8 sm:gap-16 text-sm text-slate-500 font-medium" data-id="element-100">
            <div className="flex items-center gap-2" data-id="element-101">
              <BarChart3 className="w-5 h-5 text-emerald-600" data-id="element-102" />
              <span data-id="element-103">Messbare Ergebnisse</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-104">
              <ShieldCheck className="w-5 h-5 text-emerald-600" data-id="element-105" />
              <span data-id="element-106">Praxiserprobte Methoden</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-107">
              <div className="font-bold text-slate-900" data-id="element-108">100%</div>
              <span data-id="element-109">Fokus auf B2B</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}